<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>活动管理</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list'}">活动列表</BreadcrumbItem>
      <BreadcrumbItem>下载活动海报</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <Card>
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          下载活动海报
        </p>
        <router-link :to="{name: 'meeting-list'}" slot="extra">
          <Icon type="ios-arrow-back"></Icon>
          返回列表
        </router-link>
        <swiper :options="swiperOption" ref="posterSwiper">
          <!-- slides -->
          <swiper-slide>
            <div :model="meeting" class="poster">
              <div class="print-area" ref="themeLine">
                <img class="cover" :src="`/api/admin/meetings/cover/show?path=${meeting.coverImgPath}`"/>
                <div class="wrapper">
                  <div class="inner">
                    <div class="content">
                      <h3 v-text="meeting.title"></h3>
                      <p>
                        <Icon type="ios-time-outline" style="margin-right: 3px"/>活动时间：
                        <span v-if="meeting.startDate">{{ getMeetingTime() }}</span>
                        <span v-else>待定</span>
                      </p>
                      <p>
                        <Icon type="ios-pin-outline" style="margin-right: 3px"/>举办城市：
                        {{ getCityName(meeting.addressCountry, meeting.addressProvince, meeting.addressCity) }}
                      </p>
                    </div>
                    <div class="line"/>
                    <Row type="flex" justify="center" align="middle" class="footer">
                      <Col span="8">
                      <img width="75" :src="`/api/admin/matrixToImage/downloadImg?plainText=https://bizevent.ccpit.org/meetings/${meeting.id}`"/>
                      </Col>
                      <Col span="16">
                      长按识别二维码<br/>
                      了解活动详情并报名
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              <div>
                <Icon color="#2d8cf0" class="print" size="30" type="ios-download-outline" @click="print('themeLine')"/>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div :model="meeting" class="poster">
              <div class="print-area" ref="themeNatural">
                <img class="cover" :src="`/api/admin/meetings/cover/show?path=${meeting.coverImgPath}`"/>
                <div class="content">
                  <h3 v-text="meeting.title"></h3>
                  <p>
                    <Icon type="ios-time-outline" style="margin-right: 3px"/>活动时间：
                    <span v-if="meeting.startDate">{{ getMeetingTime() }}</span>
                    <span v-else>待定</span>
                  </p>
                  <p>
                    <Icon type="ios-pin-outline" style="margin-right: 3px"/>举办城市：
                    {{ getCityName(meeting.addressCountry, meeting.addressProvince, meeting.addressCity) }}
                  </p>
                </div>
                <div class="line"/>
                <Row type="flex" justify="center" align="middle" class="footer">
                  <Col span="7">
                  <img width="75" :src="`/api/admin/matrixToImage/downloadImg?plainText=https://bizevent.ccpit.org/meetings/${meeting.id}`"/>
                  </Col>
                  <Col span="17">
                  长按识别二维码<br/>
                  了解活动详情并报名
                  </Col>
                </Row>
              </div>
              <div>
                <Icon color="#2d8cf0" class="print" size="30" type="ios-download-outline" @click="print('themeNatural')"/>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div :model="meeting" class="poster">
              <div class="print-area" ref="themeReverse">
                <div class="content">
                  <h3 v-text="meeting.title"></h3>
                  <p>
                    <Icon type="ios-time-outline" style="margin-right: 3px"/>活动时间：
                    <span v-if="meeting.startDate">{{ getMeetingTime() }}</span>
                    <span v-else>待定</span>
                  </p>
                  <p>
                    <Icon type="ios-pin-outline" style="margin-right: 3px"/>举办城市：
                    {{ getCityName(meeting.addressCountry, meeting.addressProvince, meeting.addressCity) }}
                  </p>
                </div>
                <div class="line"/>
                <Row type="flex" justify="center" align="middle" class="footer">
                  <Col span="16" style="text-align: right">
                  长按识别二维码<br/>
                  了解活动详情并报名
                  </Col>
                  <Col span="8" style="text-align: right">
                  <img width="75" :src="`/api/admin/matrixToImage/downloadImg?plainText=https://bizevent.ccpit.org/meetings/${meeting.id}`"/>
                  </Col>
                </Row>
                <img class="cover" :src="`/api/admin/meetings/cover/show?path=${meeting.coverImgPath}`"/>
              </div>
              <div>
                <Icon color="#2d8cf0" class="print" size="30" type="ios-download-outline" @click="print('themeReverse')"/>
              </div>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination"  slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </Card>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import { mapState } from 'vuex'
import moment from 'moment'
import html2canvas from 'html2canvas'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

export default {
  name: 'MeetingPoster',
  props: ['id'],
  data () {
    return {
      meeting: {
        host: null,
        organizer: null,
        briefIntroduction: null,
        agenda: null,
        contact: null,
        addressCountry: '中国',
        free: 1
      },
      attachments: [],
      saving: false,
      saved: false,
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 3,
        initialSlide: 1,
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    ...mapState([
      'token'
    ]),
    swiper () {
      return this.$refs.posterSwiper.swiper
    }
  },
  methods: {
    print (field) {
      var $that = this
      html2canvas($that.$refs[field]).then(canvas => {
        var myImage = canvas.toDataURL()
        $that.downloadURI(myImage, `${$that.meeting.title}.png`)
      })
    },
    downloadURI (uri, name) {
      var link = document.createElement('a')
      link.download = name
      link.href = uri
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    initMeeting () {
      return this.meeting
    },
    formatDate (timestamp) {
      if (timestamp) {
        moment.lang('zh-cn')
        return moment(timestamp).format('MM-DD ddd')
      } else {
        return null
      }
    },
    getCityName (country, province, city) {
      if (country === '中国') {
        if (!province) {
          return ''
        }
        if (this.isZhiXiaShi(province)) {
          return province.substring(0, province.length - 1)
        } else if (this.isHongKong(province)) {
          return '香港'
        } else if (this.isMacao(province)) {
          return '澳门'
        } else {
          if (city.indexOf('市') === city.length - 1) {
            return city.substring(0, city.length - 1)
          }
          return city
        }
      }
      return country
    },
    isZhiXiaShi: function (province) {
      if (province === '北京市' || province === '天津市' || province === '上海市' || province === '重庆市') {
        return true
      }
      return false
    },
    isHongKong: function (province) {
      return province.indexOf('香港') !== -1
    },
    isMacao: function (province) {
      return province.indexOf('澳门') !== -1
    },
    setMeeting (meeting) {
      if (meeting.onLineMeeting === null) {
        meeting.onLineMeeting = false
      }
      if (meeting.hideHost === null) {
        meeting.hideHost = false
      }
      this.meeting = meeting
      if (meeting.attachments) {
        this.attachments = meeting.attachments
      } else {
        this.attachments = []
      }
    },
    getMeeting () {
      this.meeting.attachments = this.attachments
      if (this.meeting.addressCountry !== '中国') {
        this.meeting.addressProvince = null
        this.meeting.addressCity = null
      }
      if (this.meeting.organizer === '') {
        this.meeting.organizer = null
      }
      return this.meeting
    },
    getMeetingTime () {
      moment.lang('zh-cn')
      if (!this.meeting.startDate || !this.meeting.endDate) {
        return '待定'
      }

      var startTime = moment(this.meeting.startDate).utc().zone(-8)
      var endTime = moment(this.meeting.endDate).utc().zone(-8)

      var startTimeStrPattern = 'YYYY.M.D（ddd） H:mm ~ '
      var endTimeStrPattern = 'YYYY.M.D （ddd） H:mm'

      if (endTime.year() === startTime.year() && endTime.dayOfYear() === startTime.dayOfYear()) {
        startTimeStrPattern = 'YYYY年M月D日（ddd） H:mm ~ '
        endTimeStrPattern = 'H:mm'
      } else if (endTime.year() === startTime.year() && endTime.dayOfYear() !== startTime.dayOfYear()) {
        startTimeStrPattern = 'YYYY年M月D日（ddd） ~ '
        endTimeStrPattern = 'M月D日（ddd）'
      } else if (endTime.year() !== startTime.year()) {
        startTimeStrPattern = 'YYYY年M月D日 ~ '
        endTimeStrPattern = 'YYYY年M月D日'
      }

      return startTime.format(startTimeStrPattern) + endTime.format(endTimeStrPattern)
    }
  },
  async beforeRouteEnter (to, from, next) {
    if (to.params.id) {
      try {
        let resp = await Vue.http.get(`/api/admin/meetings/${to.params.id}`)
        next(vm => {
          vm.setMeeting(resp.body)
          vm.saving = false
          vm.saved = false
        })
      } catch (e) {
        next(vm => {
          vm.setMeeting({})
          vm.saving = false
          vm.saved = false
        })
      }
    } else {
      next(vm => {
        vm.setMeeting(vm.initMeeting())
        vm.saving = false
        vm.saved = false
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    if (to.params.id) {
      try {
        let resp = await Vue.http.get(`/api/admin/meetings/${to.params.id}`)
        this.setMeeting(resp.body)
        this.saving = false
        this.saved = false
        next()
      } catch (e) {
        this.setMeeting({})
        this.saving = false
        this.saved = false
        next()
      }
    } else {
      this.setMeeting(this.initMeeting())
      this.saving = false
      this.saved = false
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
  .meeting-form {
    width: 900px;
    margin: 0 auto;
    padding-right: 180px;
  }
  .poster {
    border: 1px solid #eee;
    width: 321px;
    position: relative;
    .print {
      position: absolute;
      bottom: 12%;
      cursor: pointer;
      right: 10%
    }
    .print-area:first-child {
      padding-bottom: 10px;
    }
    .print-area {
      width: 319px;
      min-height: 500px;
      .wrapper {
        border: 1px double #ccc;
        margin: 10px;
      }
      .inner {
        border: 1px double #ccc;
        margin: 5px;
        .line:before {
          content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
          letter-spacing: 1px;
          color: #ccc;
          padding-left: 8px;
        }
      }
      .cover {
        width: 100%;
      }
      .content {
        margin-top: 10px;
        padding: 15px;
        p {
          margin: 5px 0;
        }
      }
      .line {
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .line:before {
        content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
        letter-spacing: 1px;
        color: #ccc;
        padding-left: 10px;
      }
      .footer {
        padding: 15px;
        opacity: .5;
        .description {
          float: right;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/Poster.vue